import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("a", {
        class: _normalizeClass(_ctx.linkClass),
        onClick: _cache[0] || (_cache[0] = _withModifiers(
        //@ts-ignore
        (...args) => (_ctx.goToMenuPath && _ctx.goToMenuPath(...args)), ["prevent"])),
        innerHTML: _ctx.titleToUse
    }, null, 10, _hoisted_1));
}
